<template>
<!-- <div id="sticky-nav" class="wrapper" > -->
<div class="wrapper-nav-sp" :style="`top:${navH}px`">
  <!-- <div class="count-down-num" > -->
    <div :class="navClass" >
  </div>
   </div>
</template>

<script>

import NativeMsg from '@/base/NativeMsg';
import StoreManger from '@/utils/FundHQJHManger';

export default {
  data() {
    return {
      showType: 0,
      navClass: 'nav-white',
      showweb: false,
      navH: 88,
    };
  },
  created() {
    NativeMsg.reg('refreshBarbtnSp', (res) => {
      this.showTopViewType(res.type);
    });
    this.configureLayout();
  },
  methods: {

    // 高度适配
    configureLayout() {
      this.navH = StoreManger.getNAVSTATEHEIGHT();
      // #if EXECUTION_ENV == 'web'
      this.navH = 40;
      // #endif
    },
    showTopViewType(type) {
      console.log(`showTopViewType${type}`);
      // 默认0 白色 1涨 2跌 3平
      if (type === 1) {
        this.showType = 1;
        this.navClass = 'nav-red';
      }
      if (type === 2) {
        this.showType = 2;
        this.navClass = 'nav-green';
      }
      if (type === 3) {
        this.showType = 3;
        this.navClass = 'nav-grey';
      }
      if (type === 0) {
        this.showType = 0;
        this.navClass = 'nav-white';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper-nav-sp {
  width: 100%;
  align-items: center;
  position: absolute;
  top: 176px;
  left: 0;
  z-index: 0;
}
.wrapper-nav-sp-web {
  width: 100%;
  align-items: center;
  position: absolute;
  top: 88px;
  left: 0;
  z-index: 0;
}
.nav-white {
  height: 300px;
  background-image: linear-gradient(#E93801, #f5f5f5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-red {
  height: 300px;
  background-image: linear-gradient(#E93801, #f5f5f5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-green {
  height: 300px;
  background-image: linear-gradient(#E93801, #f5f5f5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-grey {
  height: 300px;
  background-image: linear-gradient(#999999, #f5f5f5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
